// SOAPルール (v3 世界の統合ルール。FormatInsert / TextReplacement の後継)
//
// kind の意味 (適用は back の rule_applier が担う):
// - add:     会話に when_text が現れたら、section 欄に then_text を追記する
// - rewrite: SOAP 全欄の when_text を then_text に置換する (then_text 空 = 削除)
// 適用順は作成順 (一覧の見たまま)。

export type SoapRuleKind = 'add' | 'rewrite'

export type SoapSection =
  | 'subjectives'
  | 'objectives'
  | 'assessments'
  | 'educational_plans'
  | 'care_plans'
  | 'observational_plans'

export const soapSectionLabels: Record<SoapSection, string> = {
  subjectives: 'S: 主観的情報',
  objectives: 'O: 客観的情報',
  assessments: 'A: アセスメント',
  educational_plans: 'EP: 教育プラン',
  care_plans: 'CP: ケアプラン',
  observational_plans: 'OP: 観察プラン',
}

// 一覧の自然文表記用 (「EP欄に追記」等)
export const soapSectionShortLabels: Record<SoapSection, string> = {
  subjectives: 'S',
  objectives: 'O',
  assessments: 'A',
  educational_plans: 'EP',
  care_plans: 'CP',
  observational_plans: 'OP',
}

export interface SoapRule {
  id?: string
  kind: SoapRuleKind
  when_text: string
  then_text: string
  // add のみ使用 (rewrite は常に空文字)
  section: SoapSection | ''
  created_at?: string
}
